import fetchApi from "../fetchApi";

export const combineCard = async ({
  office_id = "",
  source_cards = [],
  destination_processor_reference = "",
  skip_combine_fee = false,
}) => {
  const payload = {
    office_id: office_id,
    source_cards: source_cards,
    destination_processor_reference: destination_processor_reference,
  };
  if (skip_combine_fee) {
    payload["skip_combine_fee"] = true;
  }
  const options = {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(payload),
    redirect: "follow",
  };

  return await fetchApi(`card-issuing/sell-order/combine`, options);
};
